var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-steps',{attrs:{"active":_vm.active,"finish-status":"success","align-center":""}},[_c('el-step',{attrs:{"title":"活动基础设置"}}),_c('el-step',{attrs:{"title":"邀请人设置"}}),_c('el-step',{attrs:{"title":"被邀人设置"}}),_c('el-step',{attrs:{"title":"设置确认"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }